import { type Language } from 'src/core/config/i18n';

export const getNewReleaseBaseUrl = (lang: Language) => {
  switch (lang) {
    case 'fr':
      return 'https://www.spendesk.com/fr/platform/platform-releases/nouveautes-dautomne-2025?utm_source=in-app&utm_medium=popup&utm_campaign=grouped-release-updates';
    case 'de':
      return 'https://www.spendesk.com/de/platform/platform-releases/herbst-updates-2025?utm_source=in-app&utm_medium=popup&utm_campaign=grouped-release-updates';
    case 'es':
      return 'https://www.spendesk.com/es/platform/platform-releases/novedades-de-otono-2025?utm_source=in-app&utm_medium=popup&utm_campaign=grouped-release-updates';
    default:
      return 'https://www.spendesk.com/platform/platform-releases/autumn-updates-2025?utm_source=in-app&utm_medium=popup&utm_campaign=grouped-release-updates';
  }
};
